
import React from 'react';
import "../App.css";
import { Link, useNavigate } from 'react-router-dom';

export default function LandingPage() {
    const router = useNavigate();

    return (
        <div className='landingPageContainer'>
            <nav className='landingNav'>
                <div className='navHeader'>
                    <h2>Communication App</h2>
                </div>
                <div className='navlist'>
                    <p onClick={() => router("/aljk23")}>Join as Guest</p>
                    <p onClick={() => router("/auth")}>Register</p>
                    <p onClick={() => router("/auth")}>Login</p>
                </div>
            </nav>

            <main className="landingMainContainer">
                <div className="landingText">
                    <h1><span className="highlight">Real</span> Time Communication App</h1>
                    <p>Connect to conquer the world</p>
                    <Link to={"/auth"} className="getStartedBtn">Get Started</Link>
                </div>
                <div className="landingImage">
                    <img src="/mobile.png" alt="Mobile" />
                </div>
            </main>
        </div>
    );
}
